import type { LocaleMessageBundle } from '../../types'

export const navigationMessages: LocaleMessageBundle = {
  vi: {
    'navigation.dashboard': 'Trung tâm',
    'navigation.language': 'Ngôn ngữ',
    'navigation.search.open': 'Tìm kiếm chức năng',
    'navigation.search.title': 'Tìm kiếm chức năng',
    'navigation.search.placeholder': 'Nhập tên màn hình hoặc chức năng...',
    'navigation.search.results': 'Kết quả tìm kiếm',
    'navigation.search.recent': 'Truy cập gần đây',
    'navigation.search.empty': 'Không tìm thấy chức năng phù hợp',
    'navigation.search.noRecent': 'Chưa có chức năng truy cập gần đây',
    'navigation.search.account': 'Tài khoản',
    'navigation.search.navigateHint': 'Di chuyển',
    'navigation.search.openHint': 'Mở',
    'navigation.search.closeHint': 'Đóng',
    'navigation.modules.dashboard': 'Tổng quan',
    'navigation.modules.pos': 'Bán hàng',
    'navigation.modules.table': 'Quản lý bàn',
    'navigation.modules.product': 'Hàng hóa',
    'navigation.modules.price': 'Thiết lập giá',
    'navigation.modules.inventory': 'Kho hàng',
    'navigation.modules.order': 'Giao dịch',
    'navigation.modules.customer': 'Khách hàng',
    'navigation.modules.promotion': 'Khuyến mãi',
    'navigation.modules.staff': 'Nhân viên',
    'navigation.modules.report': 'Báo cáo',
    'navigation.modules.setting': 'Cài đặt',
    'navigation.menus.dashboard.index': 'Tổng quan hệ thống',
    'navigation.menus.dashboard.quick_report': 'Báo cáo nhanh',
    'navigation.menus.dashboard.reports_revenue': 'Báo cáo doanh thu',
    'navigation.menus.dashboard.reports_finance': 'Báo cáo tài chính',
    'navigation.menus.pos.tables': 'Sơ đồ bàn',
    'navigation.menus.pos.sale': 'Bán hàng',
    'navigation.menus.pos.active_orders': 'Đơn đang xử lý',
    'navigation.menus.pos.payment': 'Thanh toán',
    'navigation.menus.pos.invoices': 'Lịch sử hóa đơn',
    'navigation.menus.pos.index': 'Bán hàng',
    'navigation.menus.pos.pos': 'Bán hàng theo bàn',
    'navigation.menus.pos.purchase_orders': 'Đặt hàng',
    'navigation.menus.pos.sales_orders': 'Đặt hàng',
    'navigation.menus.pos.kitchen': 'Bếp bar',
    'navigation.menus.pos.pos.kitchen': 'Bếp bar',
    'navigation.menus.table.index': 'Danh sách bàn',
    'navigation.menus.table.areas': 'Khu vực',
    'navigation.menus.table.prices.areas': 'Giá khu vực',
    'navigation.menus.table.statuses': 'Trạng thái bàn',
    'navigation.menus.table.reservations': 'Đặt bàn',
    'navigation.menus.table.operations': 'Chuyển / gộp bàn',
    'navigation.menus.product.index': 'Sản phẩm',
    'navigation.menus.product.groups': 'Nhóm sản phẩm',
    'navigation.menus.products.groups': 'Nhóm sản phẩm',
    'navigation.menus.product.brands': 'Thương hiệu',
    'navigation.menus.product.units': 'Đơn vị tính',
    'navigation.menus.product.locations': 'Vị trí',
    'navigation.menus.product.sale_online': 'Bán Online',
    'navigation.menus.product.prices.products': 'Bảng giá sản phẩm',
    'navigation.menus.product.promotions': 'Chương trình khuyến mãi',
    'navigation.menus.product.promotions.coupons': 'Mã giảm giá',
    'navigation.menus.product.categories': 'Danh mục sản phẩm',
    'navigation.menus.product.variants': 'Biến thể sản phẩm',
    'navigation.menus.product.combos': 'Combo / dịch vụ',
    'navigation.menus.product.barcodes': 'Barcode / SKU',
    'navigation.menus.product.images': 'Hình ảnh sản phẩm',
    'navigation.menus.price.products': 'Bảng giá sản phẩm',
    'navigation.menus.price.areas': 'Giá khu vực',
    'navigation.menus.price.promotions': 'Chương trình khuyến mãi',
    'navigation.menus.price.promotions.coupons': 'Mã giảm giá',
    'navigation.menus.price.table_areas': 'Giá theo khu vực bàn',
    'navigation.menus.price.time_ranges': 'Giá theo khung giờ',
    'navigation.menus.price.holidays': 'Giá ngày lễ',
    'navigation.menus.price.scopes': 'Phạm vi áp dụng giá',
    'navigation.menus.inventory.stocks': 'Tồn kho',
    'navigation.menus.inventory.opening_stocks': 'Tồn đầu kỳ',
    'navigation.menus.inventory.imports': 'Nhập kho',
    'navigation.menus.inventory.exports': 'Xuất kho',
    'navigation.menus.inventory.checks': 'Kiểm kho',
    'navigation.menus.inventory.audits': 'Kiểm kho',
    'navigation.menus.inventory.histories': 'Lịch sử kho',
    'navigation.menus.inventory.purchase_receipts': 'Nhập hàng',
    'navigation.menus.inventory.purchase_returns': 'Trả hàng nhập',
    'navigation.menus.inventory.transfer_orders': 'Chuyển hàng',
    'navigation.menus.inventory.suppliers': 'Nhà cung cấp',
    'navigation.menus.inventory.supplier_debts': 'Công nợ NCC',
    'navigation.menus.inventory.delivery_partners': 'Đối tác vận chuyển',
    'navigation.menus.inventory.production_orders': 'Phiếu sản xuất',
    'navigation.menus.order.index': 'Hóa đơn',
    'navigation.menus.order.invoices': 'Hóa đơn',
    'navigation.menus.order.sales_orders': 'Đặt hàng',
    'navigation.menus.order.returns': 'Trả hàng / Đổi hàng',
    'navigation.menus.order.payments': 'Chi tiết thanh toán',
    'navigation.menus.order.cash_book': 'Sổ quỹ',
    'navigation.menus.order.cash_transactions': 'Thu / chi',
    'navigation.menus.order.cash_book_types': 'Loại thu chi',
    'navigation.menus.setting.delivery_partners': 'Đối tác vận chuyển',
    'navigation.menus.setting.units': 'Đơn vị tính',
    'navigation.menus.setting.product_groups': 'Nhóm sản phẩm',
    'navigation.menus.customer.index': 'Danh sách khách hàng',
    'navigation.menus.customer.groups': 'Nhóm khách hàng',
    'navigation.menus.customer.debts': 'Công nợ khách hàng',
    'navigation.menus.customer.purchase_histories': 'Lịch sử mua hàng',
    'navigation.menus.customer.tiers': 'Hạng thành viên',
    'navigation.menus.customer.loyalty_points': 'Tích điểm thành viên',
    'navigation.menus.promotion.index': 'Chương trình khuyến mãi',
    'navigation.menus.promotion.coupons': 'Mã giảm giá',
    'navigation.menus.promotion.discounts': 'Chiết khấu hóa đơn',
    'navigation.menus.staff.index': 'Danh sách nhân viên',
    'navigation.menus.staff.offboardings': 'Nghỉ việc',
    'navigation.menus.staff.contracts': 'Hợp đồng lao động',
    'navigation.menus.staff.contracts.types': 'Loại hợp đồng',
    'navigation.menus.staff.departments': 'Bộ phận',
    'navigation.menus.staff.shifts': 'Ca làm việc',
    'navigation.menus.staff.attendances': 'Chấm công',
    'navigation.menus.staff.attendances.online': 'Chấm công trực tuyến',
    'navigation.menus.staff.attendances.history': 'Lịch sử điểm danh',
    'navigation.menus.staff.attendances.monthly_overview': 'Thống kê công tháng',
    'navigation.menus.staff.attendances.total_time': 'Thống kê tổng thời gian',
    'navigation.menus.staff.leave': 'Nghỉ phép',
    'navigation.menus.staff.overtime_requests': 'Phiếu tăng ca',
    'navigation.menus.staff.allowances': 'Phụ cấp',
    'navigation.menus.staff.salary_advances': 'Ứng lương',
    'navigation.menus.staff.insurance': 'Bảo hiểm',
    'navigation.menus.staff.roles': 'Phân quyền',
    'navigation.menus.staff.payroll': 'Bảng lương',
    'navigation.menus.staff.payroll.payslips': 'Phiếu lương',
    'navigation.menus.report.dashboard': 'Tổng quan hệ thống',
    'navigation.menus.report.dashboard.reports_finance': 'Báo cáo tài chính',
    'navigation.menus.report.dashboard.reports_revenue': 'Báo cáo doanh thu',
    'navigation.menus.report.revenue': 'Báo cáo doanh thu',
    'navigation.menus.report.shift_revenue': 'Doanh thu theo ca',
    'navigation.menus.report.shift_closing': 'Báo cáo chốt ca',
    'navigation.menus.report.day_closing': 'Báo cáo kết thúc ngày',
    'navigation.menus.report.sales': 'Báo cáo bán hàng',
    'navigation.menus.report.products': 'Báo cáo sản phẩm',
    'navigation.menus.report.inventory': 'Báo cáo kho',
    'navigation.menus.report.staffs': 'Báo cáo nhân viên',
    'navigation.menus.report.online_stats': 'Thống kê online',
    'navigation.menus.setting.branch': 'Thông tin chi nhánh',
    'navigation.menus.setting.branches': 'Quản lý chi nhánh',
    'navigation.menus.setting.billiard_lights': 'Thiết bị đèn bàn',
    'navigation.menus.setting.printers': 'Máy in',
    'navigation.menus.setting.print_templates': 'Mẫu in hóa đơn',
    'navigation.menus.setting.payment_methods': 'Phương thức thanh toán',
    'navigation.menus.setting.system': 'Cấu hình hệ thống',
    'navigation.menus.setting.activity_logs': 'Lịch sử hệ thống',
    'navigation.menus.setting.online_web': 'Cấu hình web online',
    'navigation.menus.setting.about': 'Nhà phát triển',
    'navigation.actions.dashboard': 'Về Dashboard',
    'navigation.actions.regular_sales': 'Bán thường',
  },
  en: {
    'navigation.dashboard': 'Dashboard',
    'navigation.language': 'Language',
    'navigation.search.open': 'Search functions',
    'navigation.search.title': 'Search functions',
    'navigation.search.placeholder': 'Enter a screen or function name...',
    'navigation.search.results': 'Search results',
    'navigation.search.recent': 'Recently visited',
    'navigation.search.empty': 'No matching functions found',
    'navigation.search.noRecent': 'No recently visited functions',
    'navigation.search.account': 'Account',
    'navigation.search.navigateHint': 'Navigate',
    'navigation.search.openHint': 'Open',
    'navigation.search.closeHint': 'Close',
    'navigation.modules.dashboard': 'Overview',
    'navigation.modules.pos': 'Transactions',
    'navigation.modules.table': 'Table management',
    'navigation.modules.product': 'Goods',
    'navigation.modules.price': 'Pricing',
    'navigation.modules.inventory': 'Inventory',
    'navigation.modules.order': 'Transactions',
    'navigation.modules.customer': 'Customers',
    'navigation.modules.promotion': 'Promotions',
    'navigation.modules.staff': 'Staff',
    'navigation.modules.report': 'Reports',
    'navigation.modules.setting': 'Settings',
    'navigation.menus.dashboard.index': 'System overview',
    'navigation.menus.dashboard.quick_report': 'Quick report',
    'navigation.menus.dashboard.reports_revenue': 'Revenue report',
    'navigation.menus.dashboard.reports_finance': 'Finance report',
    'navigation.menus.pos.tables': 'Table map',
    'navigation.menus.pos.sale': 'Sales',
    'navigation.menus.pos.active_orders': 'Active orders',
    'navigation.menus.pos.payment': 'Payment',
    'navigation.menus.pos.invoices': 'Invoice history',
    'navigation.menus.pos.index': 'Sales',
    'navigation.menus.pos.pos': 'Table sales',
    'navigation.menus.pos.purchase_orders': 'Purchase orders',
    'navigation.menus.pos.sales_orders': 'Sales orders',
    'navigation.menus.pos.kitchen': 'Kitchen',
    'navigation.menus.pos.pos.kitchen': 'Kitchen',
    'navigation.menus.table.index': 'Table list',
    'navigation.menus.table.areas': 'Areas',
    'navigation.menus.table.prices.areas': 'Area pricing',
    'navigation.menus.table.statuses': 'Table statuses',
    'navigation.menus.table.reservations': 'Reservations',
    'navigation.menus.table.operations': 'Move / merge tables',
    'navigation.menus.product.index': 'Products',
    'navigation.menus.product.groups': 'Product groups',
    'navigation.menus.products.groups': 'Product groups',
    'navigation.menus.product.brands': 'Brands',
    'navigation.menus.product.units': 'Units',
    'navigation.menus.product.locations': 'Locations',
    'navigation.menus.product.sale_online': 'Online sales',
    'navigation.menus.product.prices.products': 'Product price lists',
    'navigation.menus.product.promotions': 'Promotion programs',
    'navigation.menus.product.promotions.coupons': 'Coupons',
    'navigation.menus.product.categories': 'Product categories',
    'navigation.menus.product.variants': 'Product variants',
    'navigation.menus.product.combos': 'Combos / services',
    'navigation.menus.product.barcodes': 'Barcode / SKU',
    'navigation.menus.product.images': 'Product images',
    'navigation.menus.price.products': 'Product price lists',
    'navigation.menus.price.areas': 'Area pricing',
    'navigation.menus.price.promotions': 'Promotion programs',
    'navigation.menus.price.promotions.coupons': 'Coupons',
    'navigation.menus.price.table_areas': 'Prices by table area',
    'navigation.menus.price.time_ranges': 'Prices by time range',
    'navigation.menus.price.holidays': 'Holiday prices',
    'navigation.menus.price.scopes': 'Price scopes',
    'navigation.menus.inventory.stocks': 'Stock levels',
    'navigation.menus.inventory.opening_stocks': 'Opening stock',
    'navigation.menus.inventory.imports': 'Stock imports',
    'navigation.menus.inventory.exports': 'Stock exports',
    'navigation.menus.inventory.checks': 'Stock audits',
    'navigation.menus.inventory.audits': 'Stock audits',
    'navigation.menus.inventory.histories': 'Inventory history',
    'navigation.menus.inventory.purchase_receipts': 'Purchase receipts',
    'navigation.menus.inventory.purchase_returns': 'Purchase returns',
    'navigation.menus.inventory.transfer_orders': 'Stock transfers',
    'navigation.menus.inventory.suppliers': 'Suppliers',
    'navigation.menus.inventory.supplier_debts': 'Supplier debts',
    'navigation.menus.inventory.delivery_partners': 'Delivery partners',
    'navigation.menus.inventory.production_orders': 'Production orders',
    'navigation.menus.order.index': 'Invoices',
    'navigation.menus.order.invoices': 'Invoices',
    'navigation.menus.order.sales_orders': 'Sales orders',
    'navigation.menus.order.returns': 'Returns / Exchanges',
    'navigation.menus.order.payments': 'Payment details',
    'navigation.menus.order.cash_book': 'Cash book',
    'navigation.menus.order.cash_transactions': 'Cash in / out',
    'navigation.menus.order.cash_book_types': 'Cash book types',
    'navigation.menus.setting.delivery_partners': 'Delivery partners',
    'navigation.menus.setting.units': 'Product units',
    'navigation.menus.setting.product_groups': 'Product groups',
    'navigation.menus.customer.index': 'Customer list',
    'navigation.menus.customer.groups': 'Customer groups',
    'navigation.menus.customer.debts': 'Customer debts',
    'navigation.menus.customer.purchase_histories': 'Purchase history',
    'navigation.menus.customer.tiers': 'Membership tiers',
    'navigation.menus.customer.loyalty_points': 'Loyalty points',
    'navigation.menus.promotion.index': 'Promotion programs',
    'navigation.menus.promotion.coupons': 'Coupons',
    'navigation.menus.promotion.discounts': 'Invoice discounts',
    'navigation.menus.staff.index': 'Staff list',
    'navigation.menus.staff.offboardings': 'Offboarding',
    'navigation.menus.staff.contracts': 'Staff contracts',
    'navigation.menus.staff.contracts.types': 'Contract types',
    'navigation.menus.staff.departments': 'Departments',
    'navigation.menus.staff.shifts': 'Shifts',
    'navigation.menus.staff.attendances': 'Attendance',
    'navigation.menus.staff.attendances.online': 'Online attendance',
    'navigation.menus.staff.attendances.history': 'Attendance history',
    'navigation.menus.staff.attendances.monthly_overview': 'Monthly attendance statistics',
    'navigation.menus.staff.attendances.total_time': 'Total time statistics',
    'navigation.menus.staff.leave': 'Leave requests',
    'navigation.menus.staff.overtime_requests': 'Overtime requests',
    'navigation.menus.staff.allowances': 'Allowances',
    'navigation.menus.staff.salary_advances': 'Salary advances',
    'navigation.menus.staff.insurance': 'Insurance',
    'navigation.menus.staff.roles': 'Permissions',
    'navigation.menus.staff.payroll': 'Payroll tables',
    'navigation.menus.staff.payroll.payslips': 'Payslips',
    'navigation.menus.report.dashboard': 'System overview',
    'navigation.menus.report.dashboard.reports_finance': 'Finance report',
    'navigation.menus.report.dashboard.reports_revenue': 'Revenue report',
    'navigation.menus.report.revenue': 'Revenue report',
    'navigation.menus.report.shift_revenue': 'Shift revenue',
    'navigation.menus.report.shift_closing': 'Shift closing report',
    'navigation.menus.report.day_closing': 'Day closing report',
    'navigation.menus.report.sales': 'Sales report',
    'navigation.menus.report.products': 'Product report',
    'navigation.menus.report.inventory': 'Inventory report',
    'navigation.menus.report.staffs': 'Staff report',
    'navigation.menus.report.online_stats': 'Online sales statistics',
    'navigation.menus.setting.branch': 'Branch information',
    'navigation.menus.setting.branches': 'Branch management',
    'navigation.menus.setting.billiard_lights': 'Table light devices',
    'navigation.menus.setting.printers': 'Printers',
    'navigation.menus.setting.print_templates': 'Receipt templates',
    'navigation.menus.setting.payment_methods': 'Payment methods',
    'navigation.menus.setting.system': 'System configuration',
    'navigation.menus.setting.activity_logs': 'System history',
    'navigation.menus.setting.online_web': 'Online web configuration',
    'navigation.menus.setting.about': 'Developer',
    'navigation.actions.dashboard': 'Back to Dashboard',
    'navigation.actions.regular_sales': 'Regular sales',
  },
}
